import { render, staticRenderFns } from "./EditTeam.vue?vue&type=template&id=3b915ed8&scoped=true&"
import script from "./EditTeam.vue?vue&type=script&lang=js&"
export * from "./EditTeam.vue?vue&type=script&lang=js&"
import style0 from "./EditTeam.vue?vue&type=style&index=0&id=3b915ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b915ed8",
  null
  
)

export default component.exports